import React from "react"

import { AppAntSwitch } from "@components"
import { acrissCategory } from "@signals"


export default function AppCommonFiltersAcrissCategoryToggleButton({ ...props }) {
	return <AppAntSwitch
		falseText="Category"
		trueText="Acriss"
		checked={acrissCategory.value}
		onChange={newValue => acrissCategory.value = newValue.target.checked}
		{...props}
	/>
}